import {gql} from "@apollo/client";

export const getIngredients = gql`
  query getList {
    ingredients {
      id
      name
      details
    }
  }
`

export const getIngredientById = gql`
  query getItem($id: ID!) {
    ingredient( id: $id) {
      id
      name
      details
    }
  }
`

export const createIngredientMutation = gql`
  mutation create($name: String!, $details: String!){
    createIngredient(
      input: {
        name: $name,
        details: $details,
      }) {
      ingredient {
        id
        name
        details
      }
    }
  }
`

export const updateIngredientMutation = gql`
  mutation update($id: ID!, $name: String!, $details: String){
    updateIngredient(
      input: {
        id: $id,
        name: $name,
        details: $details,
      }) {
      ingredient {
        id
        name
        details
      }
    }
  }
`

export const deleteIngredientMutation = gql`
  mutation deleteIngredient($id: ID!){
    deleteIngredient(
      input: {id: $id}) {
      ingredient {
        id
      }
    }
  }
`

